import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את ההשוואה בזמן אמת",
    opening: localizedGenderNode(
      [
      "היום אני לא נלחם/ת בהשוואה. אני רק מזהה אותה כשהיא קופצת."
    ],
      [
      "היום אני לא נלחם/ת בהשוואה. אני רק מזהה אותה כשהיא קופצת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זו השוואה. לא אמת.”",
      "אני שם/ה לב איפה זה בגוף — בלי לתקן. רק לשים לב."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זו השוואה. לא אמת.”",
      "אני שם/ה לב איפה זה בגוף — בלי לתקן. רק לשים לב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי היום ההשוואה קפצה? (מקום/אדם/רשתות)\n[כאן אני כותב]",
      "2. מה בדיוק השוויתי? (מראה/כסף/הצלחה/זוגיות/שקט)\n[כאן אני כותב]",
      "3. מה ההשוואה אמרה עליי? (המשפט המדויק)\n[כאן אני כותב]"
    ],
      [
      "1. מתי היום ההשוואה קפצה? (מקום/אדם/רשתות)\n[כאן אני כותב]",
      "2. מה בדיוק השוויתי? (מראה/כסף/הצלחה/זוגיות/שקט)\n[כאן אני כותב]",
      "3. מה ההשוואה אמרה עליי? (המשפט המדויק)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "היום אני לא מאמין/ה לכל משפט שעולה. אני רק רואה אותו."
    ],
      [
      "סגירה:",
      "היום אני לא מאמין/ה לכל משפט שעולה. אני רק רואה אותו."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה + “חוזר/ת אליי”.",
      "פעם אחת היום: נשימה + “חוזר/ת אליי”."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "עובדה מול פירוש (CBT עדין)",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדות לבין הסיפור שהמוח בונה."
    ],
      [
      "היום אני מפריד/ה בין עובדות לבין הסיפור שהמוח בונה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “עובדה זה לא השפלה.”",
      "אני מסתכל/ת על המחשבה כמו ענן שעובר."
    ],
      [
      "נשימה אחת. “עובדה זה לא השפלה.”",
      "אני מסתכל/ת על המחשבה כמו ענן שעובר."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה העובדה שראיתי? (ללא פרשנות)\n[כאן אני כותב]",
      "2. איזה פירוש קפץ מיד? (“זה אומר שאני…”)\n[כאן אני כותב]",
      "3. איזו פרשנות חלופית, עדינה יותר, אפשרית — ומה קורה אם אני נשאר/ת עם העובדה בלבד?\n[כאן אני כותב]"
    ],
      [
      "1. מה העובדה שראיתי? (ללא פרשנות)\n[כאן אני כותב]",
      "2. איזה פירוש קפץ מיד? (“זה אומר שאני…”)\n[כאן אני כותב]",
      "3. איזו פרשנות חלופית, עדינה יותר, אפשרית — ומה קורה אם אני נשאר/ת עם העובדה בלבד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "הכאב שלי אמיתי — אבל הסיפור לא תמיד מדויק."
    ],
      [
      "סגירה:",
      "הכאב שלי אמיתי — אבל הסיפור לא תמיד מדויק."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “עובדה ≠ פירוש” + נשימה.",
      "פעם אחת היום: “עובדה ≠ פירוש” + נשימה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הטריגרים הקבועים",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת איפה ההשוואה הכי אוהבת להופיע."
    ],
      [
      "היום אני לומד/ת איפה ההשוואה הכי אוהבת להופיע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אם אני מכיר/ה טריגר — יש לי כוח.”",
      "אני שם/ה לב לדופק/חזה/בטן — בלי למהר."
    ],
      [
      "נשימה אחת. “אם אני מכיר/ה טריגר — יש לי כוח.”",
      "אני שם/ה לב לדופק/חזה/בטן — בלי למהר."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. 3 טריגרים מרכזיים שלי:\n[כאן אני כותב]",
      "2. איזה רגש נמצא מתחת להשוואה? (בושה/פחד/חוסר ביטחון/בדידות)\n[כאן אני כותב]",
      "3. מה אני עושה מיד אחרי טריגר? (מתכווץ/משווה עוד/נמנע/מנסה להרשים)\n[כאן אני כותב]"
    ],
      [
      "1. 3 טריגרים מרכזיים שלי:\n[כאן אני כותב]",
      "2. איזה רגש נמצא מתחת להשוואה? (בושה/פחד/חוסר ביטחון/בדידות)\n[כאן אני כותב]",
      "3. מה אני עושה מיד אחרי טריגר? (מתכווץ/משווה עוד/נמנע/מנסה להרשים)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני לא “דפוק/ה”. יש לי דפוס."
    ],
      [
      "סגירה:",
      "אני לא “דפוק/ה”. יש לי דפוס."
    ]
    ),
    action: localizedGenderNode(
      "היום אני בוחר/ת טריגר אחד ומתרגל/ת עליו עצירה של 10 שניות.",
      "היום אני בוחר/ת טריגר אחד ומתרגל/ת עליו עצירה של 10 שניות."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "ההשוואה כמנגנון הגנה",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה שהשוואה מנסה להגן עליי בדרך עקומה."
    ],
      [
      "היום אני מבין/ה שהשוואה מנסה להגן עליי בדרך עקומה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “השוואה היא ניסיון לשליטה.”",
      "אני שואל/ת: מה אני מנסה לא להרגיש?"
    ],
      [
      "נשימה אחת. “השוואה היא ניסיון לשליטה.”",
      "אני שואל/ת: מה אני מנסה לא להרגיש?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה ההשוואה מנסה למנוע ממני להרגיש?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיקרה אם אני “אהיה מאחור”?\n[כאן אני כותב]",
      "3. איזה חלק בי בוחר/ת עכשיו ביטחון?\n[כאן אני כותב]"
    ],
      [
      "1. מה ההשוואה מנסה למנוע ממני להרגיש?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיקרה אם אני “אהיה מאחור”?\n[כאן אני כותב]",
      "3. איזה חלק בי בוחר/ת עכשיו ביטחון?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "כשאני מבין/ה את המנגנון — הוא נרגע."
    ],
      [
      "סגירה:",
      "כשאני מבין/ה את המנגנון — הוא נרגע."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד: “אני רואה למה אתה עושה את זה. תודה.” ואז נשימה.",
      "משפט אחד: “אני רואה למה אתה עושה את זה. תודה.” ואז נשימה."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "להחזיר ערך עצמי לבית (לא החוצה)",
    opening: localizedGenderNode(
      [
      "היום אני מחזיר/ה את המדידה אליי — לא לעולם."
    ],
      [
      "היום אני מחזיר/ה את המדידה אליי — לא לעולם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “החיים שלי לא תחרות.”",
      "אני שם/ה לב למה טוב בי עכשיו, אפילו קטן."
    ],
      [
      "נשימה. “החיים שלי לא תחרות.”",
      "אני שם/ה לב למה טוב בי עכשיו, אפילו קטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. באיזה תחום אני מרגיש/ה “פחות”?\n[כאן אני כותב]",
      "2. מה הדבר האמיתי בי שלא נמדד שם?\n[כאן אני כותב]",
      "3. איזה ערך אחד אני רוצה למדוד את עצמי לפיו? (אמת/כבוד/שקט/צמיחה)\n[כאן אני כותב]"
    ],
      [
      "1. באיזה תחום אני מרגיש/ה “פחות”?\n[כאן אני כותב]",
      "2. מה הדבר האמיתי בי שלא נמדד שם?\n[כאן אני כותב]",
      "3. איזה ערך אחד אני רוצה למדוד את עצמי לפיו? (אמת/כבוד/שקט/צמיחה)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "ערך עצמי לא נמדד מול אנשים. הוא נבנה מבפנים."
    ],
      [
      "סגירה:",
      "ערך עצמי לא נמדד מול אנשים. הוא נבנה מבפנים."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת 3 ערכים/תכונות “שלי בלבד” ושומר/ת ביומן.",
      "אני כותב/ת 3 ערכים/תכונות “שלי בלבד” ושומר/ת ביומן."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "רשתות חברתיות: ניקוי עדין",
    opening: localizedGenderNode(
      [
      "היום אני מפחית/ה חשיפה שמדליקה השוואה."
    ],
      [
      "היום אני מפחית/ה חשיפה שמדליקה השוואה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “אני לא רוצה/ת להיכנס למדורה.”",
      "לפני פתיחת רשת — נשימה אחת ושאלה: “זה טוב לי עכשיו?”"
    ],
      [
      "נשימה. “אני לא רוצה/ת להיכנס למדורה.”",
      "לפני פתיחת רשת — נשימה אחת ושאלה: “זה טוב לי עכשיו?”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה סוג תוכן הכי מפעיל אותי?\n[כאן אני כותב]",
      "2. מה אני מחפש/ת שם באמת? (אישור/תקווה/בריחה/השראה?)\n[כאן אני כותב]",
      "3. מה גבול קטן שיגן עליי השבוע?\n[כאן אני כותב]"
    ],
      [
      "1. איזה סוג תוכן הכי מפעיל אותי?\n[כאן אני כותב]",
      "2. מה אני מחפש/ת שם באמת? (אישור/תקווה/בריחה/השראה?)\n[כאן אני כותב]",
      "3. מה גבול קטן שיגן עליי השבוע?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "גבול הוא כבוד עצמי."
    ],
      [
      "סגירה:",
      "גבול הוא כבוד עצמי."
    ]
    ),
    action: localizedGenderNode(
      "היום אני מסיר/ה/משתיק/ה טריגר אחד.",
      "היום אני מסיר/ה/משתיק/ה טריגר אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להפוך השוואה למידע (לא לשיפוט)",
    opening: localizedGenderNode(
      [
      "אם אני מקנא/ה או משווה — אולי זה אומר לי מה אני רוצה."
    ],
      [
      "אם אני מקנא/ה או משווה — אולי זה אומר לי מה אני רוצה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “השוואה יכולה להפוך למצפן.”",
      "אני שם/ה לב ל”דקירה” — ושואל/ת: מה היא רוצה לספר?"
    ],
      [
      "נשימה. “השוואה יכולה להפוך למצפן.”",
      "אני שם/ה לב ל”דקירה” — ושואל/ת: מה היא רוצה לספר?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. במי/במה השוויתי היום?\n[כאן אני כותב]",
      "2. מה זה מגלה שאני באמת רוצה?\n[כאן אני כותב]",
      "3. מה צעד 10% קטן בכיוון הזה?\n[כאן אני כותב]"
    ],
      [
      "1. במי/במה השוויתי היום?\n[כאן אני כותב]",
      "2. מה זה מגלה שאני באמת רוצה?\n[כאן אני כותב]",
      "3. מה צעד 10% קטן בכיוון הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני מפסיק/ה להעניש את עצמי עם ההשוואה — ומתחיל/ה להשתמש בה נכון."
    ],
      [
      "סגירה:",
      "אני מפסיק/ה להעניש את עצמי עם ההשוואה — ומתחיל/ה להשתמש בה נכון."
    ]
    ),
    action: localizedGenderNode(
      "צעד 10% אחד בלבד.",
      "צעד 10% אחד בלבד."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חשיפה עדינה (ACT): להיות עם ההשוואה בלי לברוח",
    opening: localizedGenderNode(
      [
      "היום אני מאפשר/ת להשוואה להיות כאן דקה — בלי פעולה."
    ],
      [
      "היום אני מאפשר/ת להשוואה להיות כאן דקה — בלי פעולה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “זה גל.”",
      "אני מאפשר/ת לתחושה להיות — רק נשימה."
    ],
      [
      "נשימה. “זה גל.”",
      "אני מאפשר/ת לתחושה להיות — רק נשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הטריגר היום?\n[כאן אני כותב]",
      "2. מה קרה בגוף אחרי דקה?\n[כאן אני כותב]",
      "3. מה למדתי? (האם זה באמת “לא עובר”?)\n[כאן אני כותב]"
    ],
      [
      "1. מה הטריגר היום?\n[כאן אני כותב]",
      "2. מה קרה בגוף אחרי דקה?\n[כאן אני כותב]",
      "3. מה למדתי? (האם זה באמת “לא עובר”?)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני מתחזק/ת כי נשארתי."
    ],
      [
      "סגירה:",
      "אני מתחזק/ת כי נשארתי."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. עקביות > כוח.",
      "דקה אחת בלבד. עקביות > כוח."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "בושה מתחת להשוואה",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בבושה בלי לתת לה לפרק אותי."
    ],
      [
      "היום אני נוגע/ת בבושה בלי לתת לה לפרק אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “בושה היא כאב, לא אמת.”",
      "יד על חזה/בטן (אם נעים) ונשימה אחת."
    ],
      [
      "נשימה. “בושה היא כאב, לא אמת.”",
      "יד על חזה/בטן (אם נעים) ונשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה המשפט המבייש שעולה?\n[כאן אני כותב]",
      "2. מה הייתי אומר/ת לחבר אהוב עם אותו משפט?\n[כאן אני כותב]",
      "3. מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום?\n[כאן אני כותב]"
    ],
      [
      "1. מה המשפט המבייש שעולה?\n[כאן אני כותב]",
      "2. מה הייתי אומר/ת לחבר אהוב עם אותו משפט?\n[כאן אני כותב]",
      "3. מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "חמלה מרפאה יותר מהוכחה."
    ],
      [
      "סגירה:",
      "חמלה מרפאה יותר מהוכחה."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד בלבד, פעם אחת.",
      "משפט רך אחד בלבד, פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "להפסיק “לנצח” כדי להיות ראוי/ה",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המאמץ להיות “יותר” — ומשחרר/ת קצת."
    ],
      [
      "היום אני רואה את המאמץ להיות “יותר” — ומשחרר/ת קצת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “אני לא בוחר/ת/ה לנצח כדי להיות אהוב/ה.”",
      "אני שם/ה לב לאיפה אני מתכווץ/ת כדי להרשים."
    ],
      [
      "נשימה. “אני לא בוחר/ת/ה לנצח כדי להיות אהוב/ה.”",
      "אני שם/ה לב לאיפה אני מתכווץ/ת כדי להרשים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה אני מנסה להוכיח שאני שווה?\n[כאן אני כותב]",
      "2. מה המחיר של זה?\n[כאן אני כותב]",
      "3. איך נראה “מספיק” קטן אחד היום?\n[כאן אני כותב]"
    ],
      [
      "1. איפה אני מנסה להוכיח שאני שווה?\n[כאן אני כותב]",
      "2. מה המחיר של זה?\n[כאן אני כותב]",
      "3. איך נראה “מספיק” קטן אחד היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני ראוי/ה גם כשאני פשוט אני."
    ],
      [
      "סגירה:",
      "אני ראוי/ה גם כשאני פשוט אני."
    ]
    ),
    action: localizedGenderNode(
      "היום אני עושה דבר אחד בלי להסביר/להוכיח.",
      "היום אני עושה דבר אחד בלי להסביר/להוכיח."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "השוואה בתוך קשרים (לא רק רשתות)",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב איך השוואה נכנסת לקשרים."
    ],
      [
      "היום אני שם/ה לב איך השוואה נכנסת לקשרים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “אני לא רוצה/ת להיות ‘יותר’ כדי להישאר.”",
      "אני מרגיש/ה את הצורך להיות מושלם/ת — ומרפה נשימה אחת."
    ],
      [
      "נשימה. “אני לא רוצה/ת להיות ‘יותר’ כדי להישאר.”",
      "אני מרגיש/ה את הצורך להיות מושלם/ת — ומרפה נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מול מי אני משווה את עצמי בקשרים?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיקרה אם אני ‘פחות’?\n[כאן אני כותב]",
      "3. איזה גבול פנימי קטן יעזור לי?\n[כאן אני כותב]"
    ],
      [
      "1. מול מי אני משווה את עצמי בקשרים?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיקרה אם אני ‘פחות’?\n[כאן אני כותב]",
      "3. איזה גבול פנימי קטן יעזור לי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "קשר אמיתי לא דורש תחרות."
    ],
      [
      "סגירה:",
      "קשר אמיתי לא דורש תחרות."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “אני נשאר/ת אני.” + נשימה.",
      "פעם אחת היום: “אני נשאר/ת אני.” + נשימה."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "שפה פנימית חדשה",
    opening: localizedGenderNode(
      [
      "היום אני משנה משפט אחד שמנהל אותי."
    ],
      [
      "היום אני משנה משפט אחד שמנהל אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “מילים הן בית.”",
      "אני מקשיב/ה למילים בראש כאילו הן מוזיקה — אפשר לשנות תדר."
    ],
      [
      "נשימה. “מילים הן בית.”",
      "אני מקשיב/ה למילים בראש כאילו הן מוזיקה — אפשר לשנות תדר."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה המשפט ההשוואתי המרכזי שלי?\n[כאן אני כותב]",
      "2. איך אותו משפט נשמע בגרסה אנושית ורכה?\n[כאן אני כותב]",
      "3. מה משפט אחד חדש שאני מאמץ/ת לשבוע?\n[כאן אני כותב]"
    ],
      [
      "1. מה המשפט ההשוואתי המרכזי שלי?\n[כאן אני כותב]",
      "2. איך אותו משפט נשמע בגרסה אנושית ורכה?\n[כאן אני כותב]",
      "3. מה משפט אחד חדש שאני מאמץ/ת לשבוע?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "כשאני משנה מילה — אני משנה כיוון."
    ],
      [
      "סגירה:",
      "כשאני משנה מילה — אני משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "היום אני משתמש/ת במשפט החדש פעם אחת בלבד.",
      "היום אני משתמש/ת במשפט החדש פעם אחת בלבד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבנות זהות בלי מדידה",
    opening: localizedGenderNode(
      [
      "היום אני בונה זהות של אדם שמתקדם, לא אדם שמשווה."
    ],
      [
      "היום אני בונה זהות של אדם שמתקדם, לא אדם שמשווה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “אני בדרך.”",
      "אני שואל/ת: מה חשוב לי באמת, בלי קשר לאחרים?"
    ],
      [
      "נשימה. “אני בדרך.”",
      "אני שואל/ת: מה חשוב לי באמת, בלי קשר לאחרים?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה ערך אחד אני רוצה להוביל אותי?\n[כאן אני כותב]",
      "2. איזה הרגל קטן משרת את הערך הזה השבוע?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי ביום של השוואה חזקה?\n[כאן אני כותב]"
    ],
      [
      "1. איזה ערך אחד אני רוצה להוביל אותי?\n[כאן אני כותב]",
      "2. איזה הרגל קטן משרת את הערך הזה השבוע?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי ביום של השוואה חזקה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה:",
      "אני לא תחרות. אני מסע."
    ],
      [
      "סגירה:",
      "אני לא תחרות. אני מסע."
    ]
    ),
    action: localizedGenderNode(
      "אני מתכנן/ת פעולה קטנה אחת לשבוע שמחזירה לי יציבות.",
      "אני מתכנן/ת פעולה קטנה אחת לשבוע שמחזירה לי יציבות."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה: לחזור הביתה",
    opening: localizedGenderNode(
      [
      "היום אני סוגר/ת פרק בלי לנצח. אני חוזר/ת הביתה."
    ],
      [
      "היום אני סוגר/ת פרק בלי לנצח. אני חוזר/ת הביתה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה. “אני בעדי.”",
      "אני מרגיש/ה את הרצפה מתחתיי. אני כאן."
    ],
      [
      "נשימה. “אני בעדי.”",
      "אני מרגיש/ה את הרצפה מתחתיי. אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה השתנה בי במסע הזה? (3 דברים)\n[כאן אני כותב]",
      "2. מה נהיה ברור לי על השוואה?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים (קצר, בכיס):\n[כאן אני כותב]"
    ],
      [
      "1. מה השתנה בי במסע הזה? (3 דברים)\n[כאן אני כותב]",
      "2. מה נהיה ברור לי על השוואה?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים (קצר, בכיס):\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא מוחק/ת את ההשוואה.",
      "אני פשוט מפסיק/ה לתת לה לנהל אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא מוחק/ת את ההשוואה.",
      "אני פשוט מפסיק/ה לתת לה לנהל אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת “אני חוזר/ת אליי”: הליכה / כתיבה 5 שורות / ניקוי קטן / שיחה עם אדם בטוח.",
      "פעולה אחת שמסמלת “אני חוזר/ת אליי”: הליכה / כתיבה 5 שורות / ניקוי קטן / שיחה עם אדם בטוח."
    ),
  },
].map(buildNormalizedDay);

export const constantComparisonToOthersBlueprintHe = buildNormalizedPilotBlueprint({
  id: "constant_comparison_to_others_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "constant_comparison_to_others",
  category: "general",
  journeyName: {
    he: "השוואה תמידית לאחרים",
    en: "Constant Comparison to Others",
    es: "Comparación constante con los demás",
  },
  days,
});

export default constantComparisonToOthersBlueprintHe;
